module.exports = __webpack_public_path__ + "static/media/homegrey.42105c89.svg";